<template>
  <div style="display: inline-block;width: 100%;height: 100%;">
    <div v-if="!manageLicense" style="height: 100%;">
        <div style="display: flex;justify-content: flex-end;padding: 15px;height:64px;">
            <div style="display:flex;width: 100%;justify-content: space-between;">
                <div class="search-bar-comm-style">
                    <input
                        type="text"
                        v-model="searchedKey"
                        class="rounded text-light search-bar"
                        :placeholder="$t('Search token name')"
                        v-on:keyup="getAllAccessTokenData(false,true)"/>
                </div>
                <button @click="createNewAccessToken()" class="btn btn-outline-primary mr-2" style="height:39px;">{{$t('Create Access Token')}}</button>
            </div>
        </div>
        <div class="widget-sub-wrapper" style="height=calc(100% - 100px);display:inline-block;width:100%;">
            <table class="tabletable-with-border table-scroll small-first-col table-cell-styles" style="background: transparent;margin:0px 10px !important;width:100%">
                <thead>
                    <tr style="height: 40px;">
                        <th style="width: 25%;text-align:start">{{$t('Access Token Name')}}</th>
                        <th style="width: 20%;text-align:start">{{$t('Client Name')}}</th>
                        <th style="width: 20%;text-align:start" >{{$t('Application Name')}}</th>
                        <th style="width: 20%;" class="text-center">{{$t('Created Date')}}</th>
                        <th style="width: 15%;" class="text-center">{{$t('Status')}}</th>
                    </tr>
                </thead>
                <tbody v-if="accessTokenArr && accessTokenArr.length > 0">
                        <tr
                            v-for="token in accessTokenArr" :key="token._id"
                            v-on:click="openDialogToCopyTokenid = true; selectedAccessTokenInfo = token"
                            class="comm-table-row show-edit-delete-icon">
                            <td class="text-left underline-on-hover">
                                <span>{{token.token_name}}</span>
                            </td>
                            <td style="text-align:start">
                                <span>{{token.client_name?token.client_name:'-'}}</span>
                            </td>

                            <td style="text-align:start">
                                <span>{{token.application_name?token.application_name:'-'}}</span>
                            </td>

                            <td>
                                <span :title="getDateAndTimeInConfiguredFormat(token.created_datetime)">{{token.created_datetime?getDateAndTimeInConfiguredFormat(token.created_datetime, true):'-'}}</span>
                            </td>

                            <td>          
                                <span v-if="token.approval_status && token.approval_status == 'approved'"
                                    class="text-success"
                                    >Approved</span>
                                <span v-else class="text-danger">Pending</span>
                                <div>
                                    <svg @click.stop.prevent="deleteSelectedAccessToken(token)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash token-actions-styles" viewBox="0 0 16 16" style="margin-inline-start:10px;">
                                        <title>Delete</title>
                                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                                        <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                                    </svg>
                                    <svg @click.stop.prevent="editSelectedTokenInfo(token)" style="inset-inline-end :53px;border-radius: 0px;" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pen-fill token-actions-styles" viewBox="0 0 16 16">
                                        <title>Edit</title>
                                        <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001z"/>
                                    </svg> 
                                    <svg @click.stop.prevent="openDialogToCopyTokenid = true; selectedAccessTokenInfo = token" style="inset-inline-end :106px !important;border-radius: 5px 0px 0px 5px;" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye token-actions-styles" viewBox="0 0 16 16">
                                        <title>View</title> 
                                        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
                                        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
                                    </svg>  
                                </div>           
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                            <tr>
                                <td colspan="6" class="loading">No Data Found</td>
                            </tr>
                    </tbody> 
            </table>
        </div>
        <pagination
            v-if="!searchedKey"
            v-model="page"
            :records="totalTokens"
            :per-page="tokensPerPage"
            @paginate="paginate"
            :options="options"
            :first = "Prev"
            :last = "Next"
            style="margin-top:10px"
        />    
    </div>

    <addOrEditAccessToken v-if="showAcccessTokenFields" :modalType='accessTokenModalTYpe' :selectedAccessTokenInfo="selectedAccessTokenInfo" @closeAccessTokenModal="closeAccessTokenModal"></addOrEditAccessToken>
  

  <div v-if="openDialogToCopyTokenid">
        <div class="modal right" tabindex="-1" role="dialog" id="exampleModalLong">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header p-2">
                        <h6 class="modal-title">{{selectedAccessTokenInfo.token_name}}</h6>
                        <button
                            class="close text-white"
                            data-dismiss="modal"
                            aria-label="Close"
                            v-on:click="closeDialog()"
                            title="Close"
                            >
                            <span aria-hidden="true">
                                <cancel-icon tabindex="0" class="close-icon categorybrowse" style="height: 30px !important;
                                    width: 30px !important;
                                    color: #fff;">
                                </cancel-icon>
                            </span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div style="margin-bottom:6px;color: #8b8b8b;">Client Access Token</div>
                        <div style="display: flex;justify-content: space-between;align-items: center;">
                            <div id="copy_the_text" style="cursor: text;pointer-events: all;user-select: text;margin-inline-end: 15px;">{{selectedAccessTokenInfo.token_id}}</div>
                            <button v-on:click="copyTheText(selectedAccessTokenInfo.token_id)" data-dismiss="modal" class="btn btn-outline-secondary mr-2" style="height: 30px;padding: 0px 8px;">copy</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  
  
  </div>
</template>

<script>

import Pagination from "vue-pagination-2";
import addOrEditAccessToken from "./CreatedEditAccessToken.vue";
import Utils from "../../components.utils.js";
import { mapActions, mapMutations } from "vuex";
import cancelIcon from "../core/InlineCancelField.vue"

export default {
  data() {
    return {
        options:{chunk:5},
        page: 1,
        totalTokens: -1,
        tokensPerPage: -1,
        show:false,
        showAcccessTokenFields:false,
        manageLicense:false,
        accessTokenArr:[],
        accessTokenModalTYpe: 'add',
        currentPage:1,
        searchedKey:null,
        selectedAccessTokenInfo:null,
        openDialogToCopyTokenid:false
        
    }
  },
  components:{
        Pagination,
        'cancel-icon':cancelIcon,
        addOrEditAccessToken
    },
  methods : {
    ...mapActions("settings",["updateClientAccessToken","getAllAccessTokens","deleteClientAccessToken","createClientAccessToken","getClientAccessTokenStatus"]),
    createNewAccessToken(){
        this.accessTokenModalTYpe = 'add';
        this.showAcccessTokenFields = true;
    },
    closeDialog(){
        this.openDialogToCopyTokenid = false;
    },
    closeAccessTokenModal(){
        this.accessTokenModalTYpe = 'add';
        this.showAcccessTokenFields = false;
    },
    formatedDate(date){
        return Utils.getDateTimeFormat(date);
    },
    getAllAccessTokenData(isPageClick = false, keywordSearch = false){
        let payload = {'params':{}};
        if(isPageClick){
            payload.params["page"] = this.page;
        }
        if(keywordSearch && this.searchedKey && this.searchedKey.length > 0){
            payload.params["token_name"]  = this.searchedKey;
        }
        this.getAllAccessTokens(payload).then((data) => {
            this.accessTokenArr= data.data["client_access_tokens"];
            this.totalTokens = data.data["total_client_access_tokens"];
            this.tokensPerPage = data.data["client_access_tokens_per_page"];
        });
    },
    editSelectedTokenInfo(tokenInfo){
        this.accessTokenModalTYpe = 'edit';
        this.showAcccessTokenFields = true;
        this.selectedAccessTokenInfo = tokenInfo;
    },
    deleteSelectedAccessToken(tokenInfo){
        if (confirm(`Are you sure you want to delete access token : "${tokenInfo.token_name}"?`)) {
                let payload = {};
                payload = {"id":tokenInfo._id} // Doubt
                this.deleteClientAccessToken(payload).then((data) => {
                    if (data.statusCode==200){
                        this.$toast.success(data.message);
                    }else{
                        this.$toast.error(data.message);
                    }
                })
        }else{
            return false;
        }
    },

    paginate() {
        this.getAllAccessTokenData(true)
    },

    copyTheText(text) {
        navigator.clipboard.writeText(text);
    },

    handleNotification(notification){
        if (notification){
            let notificationData = notification.detail;
          if ((notificationData.message_type == "ACCESS_TOKEN_UPDATED")&&(notificationData.message)){
            let updated_token = notificationData.message
            let changed_token = this.accessTokenArr.filter((token)=>token._id==updated_token._id)
            if (changed_token.length !=0){
              Object.assign(changed_token[0], updated_token)
            }
          }else if ((notificationData.message_type == "ACCESS_TOKEN_CREATED")&&(notificationData.message)){
            let created_token = notificationData.message
            let token_exists = this.accessTokenArr.filter((token)=>token._id==created_token._id)
            if (token_exists.length ==0){
              this.accessTokenArr.unshift(created_token)
            }
          }else if ((notificationData.message_type == "ACCESS_TOKEN_DELETED")&&(notificationData.message)){
            let deleted_token = notificationData.message
            this.accessTokenArr = this.accessTokenArr.filter((token)=>token._id!=deleted_token._id)
          }
        }
    },

    registerforWebsocketNotifications(){
        this.addWSEventListener({
            eventname:["ACCESS_TOKEN_CREATED","ACCESS_TOKEN_UPDATED","ACCESS_TOKEN_DELETED"],
            callback:this.handleNotification,
            parent: "token"});
    },

    UnregisterfromWebsocketNotifications(){
        this.removeWSEventListener({
            eventname:["ACCESS_TOKEN_CREATED","ACCESS_TOKEN_UPDATED","ACCESS_TOKEN_DELETED"],
            callback:this.handleNotification,
            parent: "token"});
    },


    ...mapMutations("websocket",["addWSEventListener","removeWSEventListener"]),
  },
    mounted(){
        this.registerforWebsocketNotifications();
        setTimeout(() => {
        this.show = true;
        }, 200)
    },

    beforeDestroy(){        
        this.UnregisterfromWebsocketNotifications()
    },
    created(){
        this.getAllAccessTokenData();
    }
};
</script>

<style lang="scss" scoped>
    $active-green-icon-color: #00ff3a;
    $count-bg-color:#e7c20b;
    $count-border-color:#373737;
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $panel-heading-font-size:18px;
    $secondary-border-color: 1px solid #2b2b2b;
    $widgets-bg-color: #202729;
    $widget-dropdown-color: #171717;
    $icon-hover:#2c3339;

    .modal-dialog {
        max-width: 600px;
        width: 600px;
        margin: 0;
        padding: 0;
    }

    .modal{
        transition: opacity .3s ease;
    }

    
    .modal-content {
        min-height: 100%;
        border: 0 none;
        border-radius: 0;
        box-shadow: none;
        background: $primary-background !important;
        border: $secondary-border-color;
        .modal-body{
            background: $primary-background;
            padding: 15px;
        }
    }
    .modal-header,.modal-footer{
        border-top: $secondary-border-color !important;
        border-bottom: $secondary-border-color !important;
        background: $secondary-background-color;
        height: 58px;
        align-items: center;
        .modal-title{
            color:$text-color;
        }
    }

    .modal {
        text-align: center;
        padding: 0 !important;
        display: block;
        position: fixed;
        inset-inline-start: 0px;
        top: 20%;
    }
    .modal-header .close {
        margin: 0px !important;
        padding: 0px !important;
    }
    .modal:before {
        content: '';
        display: inline-block;
        height: 100vh;
        vertical-align: middle;
        margin-inline-end: -4px;
        position: fixed;
        width: 100vw;
        inset-inline-start: 0;
        top: 0;
        background: #00000094;
    }
    .modal-dialog {
        display: inline-block;
        text-align: start;
        vertical-align: middle;
    }

    
    .icon-background-on-hover:hover{
        background: #d1d2d31a;
    }

    .icon-background-on-hover{
        padding: 6px;
        height: 40px;
        width: 45px;
        border-radius: 4px;
        margin: 4px;
    }

    .widget-sub-wrapper{
        display: flex;
        flex-direction: column;
        overflow: auto;
        overflow-x:hidden;
        padding-bottom:10px;
        padding-top: 4px;
        height:calc(100% - 124px);
        .widget-sub-styles{
            background: $widgets-bg-color;
            margin: 5px;
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            border-radius: 4px;
            .widget-sub-heading{
                font-size: 17px;
                display: flex;
                position: relative;
                inset-inline-start: 10px;
                color:$secondary-text-color;
            }
            .widget-sub-value{
                font-size: 50px;
                color:#cfcfcf;
            }
        }
    }

    .progress{
        background: transparent;
        border: $border-color;
        border-radius: 3px;
    }

    .other-info{
        font-size: 12px;
        color: $secondary-text-color;
        span{
            color:$text-color !important;
        }
    }
    
    .dashboard-widget{
        background: $widgets-bg-color;
        // box-shadow: 0px 0px 9px 1px #141414;
        border-radius: 4px;
    }

    .table-scroll {
        /*width:100%; */
        border: none !important;
        /* Decoration */
        border-spacing: 0;
        margin: 0px 15px;
        thead {
            color: $dull-text-color !important;
            position: relative;
            width: 100%;
            th {
            position: sticky;
            top: -5px;
            background: $primary-background;
            z-index: 9;
            }
        }
        tbody {
            width: 100%;
            overflow: auto;
            font-weight: 500;
            tr {
            height: 45px;
            }
            tr:hover{
                background: $bg-color-on-hover;
            }
        }
    }

    .table {
        th {
            border-top: none !important;
            padding:0 10px !important;
        }
        td {
            border-top: none !important;
            padding:0 1rem!important;
        }
    }

    th {
        border-top: none !important;
        padding:0 10px !important;
    }

    .table-cell-styles{
        td{
            padding:5px 10px !important;
        }
    }

    .table-with-border {
        thead {
            border-bottom: $border-color;
        }
        tr {
            border-bottom: $border-color;
        }
    }

    .user-name-or-image{
        height: 30px;
        width: 30px;
        border: $border-color;
        border-radius: 10px;
        text-align: center;
        text-transform: uppercase;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 1px;
        line-height: unset;
    }

    .user-name{
        margin-inline-end: 10px;
    }

    svg.svg-icon {
        width: 20px;
        height: 20px;
        padding-top: 3px;
        padding-inline-start: 2px;
    }

    .priority-as-tag{
        display: flex;
        border: 1px solid #3a3a3a;
        padding-inline-end: 3px;
        border-radius: 16px;
        background: #282d31;
        margin: 4px 0px;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        height:30px;
        width:80px;
    }

    .show-edit-delete-icon{
        position: relative;
    }

    .show-edit-delete-icon:hover{
        .token-actions-styles{
            visibility: visible;
        }
    }

    .token-actions-styles{
        margin-inline-start: 10px;
        margin-inline-end:10px;
        position: absolute;
        inset-inline-end: 0px;
        z-index: 1;
        background: #525252;
        border:1px solid #262626;
        width: 55px;
        height: 44px;
        padding: 12px;
        top: 0px;
        border-radius: 0px 5px 5px 0px;
        visibility: hidden;
    }

    /* width */
    ::-webkit-scrollbar {
        width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $scrollbar-track-background;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $scrollbar-thumb-background;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $scrollbar-thumb-on-hover-background;
    }

    .secondary-btn-style{
    color:$text-color;
    }


    .search-bar-comm-style {
    select {
        border: $border-color;
        top: 0%;
        inset-inline-start: 8%;
        height: 25px;
        padding-inline-start: 3px;
    }
    }

    .text-color{
    color:$dull-text-color;
    line-height:20px;
    }

    .config-desc{
    color: $dull-text-color;
    }

    .comm-tag-title-hover:hover{
        text-decoration: underline;
    }

    .loading{
        color: $dull-text-color;
        position: relative;
        top: 40px;
    }

 ::v-deep{
    .page-item.disabled .page-link {
        background-color: $primary-background !important;
        border: $border-color !important;
     }
    .page-item.active .page-link {
        background-color: $primary-background !important;
        border: $border-color !important;
        color:$active-blue;
    }
    .page-link {
        background-color: $primary-background !important;
        border: $border-color !important;
        // border: none !important;
        color:$text-color;
        padding: 5px !important;
    }
    .page-link:hover {
        background-color: $secondary-background-color !important;
        color: $text-color !important;
    }
    .pagination {
        float: inline-end;
        margin-bottom: 0px !important;
        margin-inline-end: 8px;
    }
    .VuePagination__count {
        color: #797979 !important;
        margin-bottom: 0px !important;
        font-size: 12px;
        margin-inline-end: 7px;
        margin-top: 1px;
        float:inline-start;
        display:none;
        margin-inline-start:5px;
    }
    .VuePagination__pagination-item {
        font-size: 14px;
        width: 27px;
    }
    .VuePagination__pagination-item-prev-chunk {
        display:none;
    }
    .VuePagination__pagination-item-next-chunk{
        display:none;
    }

    .VuePagination__pagination-item-prev-page{
        width:50px !important;
    }

    .VuePagination__pagination-item-next-page{
        width:50px !important;
    }

    .VuePagination__pagination-item-next-page a:before{
        width:50px;
    content: "next ";
    }

    .VuePagination__pagination-item-prev-page a:after{
        width:50px;
    content: " prev";
    }
    .v-list{
        padding:0px !important;
    }
    .v-list-item{
        text-align: start;
        border: 1px solid #242424 !important;
        min-height: 37px !important;
        padding: 0 10px !important;
        font-size: 12px !important;
            .v-list-item__title{
                font-size: 14px !important;
                color:$text-color !important;
            }
    }
    .v-menu__content{
        width:150px !important;
    }
 }

    .btn{
    border-radius: 0.25rem !important;
    }

    .comm-table-row{
        height:45px;
    }

    .underline-on-hover:hover{
        text-decoration: underline;
    }
    
    .search-bar-comm-style {
    .search-bar{
        background: $primary-background!important;
        height:40px;
        width: 250px !important;
        margin-inline-start: 3%;
        padding-inline-start: 12px;
        padding-bottom: 2px;
        border: $border-color !important;
    }
    }

::v-deep{
    .v-btn{
      text-transform: inherit;
    }
    .v-card__title, .v-card__actions{
        background: $secondary-background-color !important;
        padding:8px;
        border-bottom: $secondary-border-color;
    }
    .v-card__text{
        background: $primary-background !important;
    }

    .v-card__actions{
        border-top: $secondary-border-color;
    }

    .save-btn.v-btn--outlined {
        border: thin solid #007bff;
    }

    .theme--dark.v-btn.v-btn--outlined.v-btn--text {
        border-color: #007bff;
    }

    .v-card.v-sheet.theme--dark{
        border: $secondary-border-color;
    }

    .v-text-field__slot{
        margin-inline-start:-10px;
    }
     .v-text-field {
        input {
                margin-inline-start: 12px;
                margin-top: 16px;
                color:$text-color
        }
     }
}

svg{
    fill:$text-color;
}

.secondary-btn-style:hover {
    text-decoration: underline;
}

.input-fields {
  border: none !important;
  border-bottom: 1px solid #007bff !important;
  height:30px;
}

.input-fields:focus {
  outline: unset;
  box-shadow:none;
}
.close-icon:hover{
  background: $secondary-background-color;
  border-radius: 20px;
  fill:$text-color;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    height: 58px;
    .modal-title{
      color:$text-color;
    }
}

.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}

</style>





